import * as React from 'react';

import type { ColorPalette } from '@acceligentllc/shared/enums/color';

import Tag from 'af-components/Controls/Tag';

interface Props {
	data: {
		color: ColorPalette;
		name: string;
	};
	onRemove: () => void;
}

const SkillMultiValueLabel = (props: Props) => {
	const { data, onRemove } = props;

	return (
		<Tag color={data.color} size="small">
			<span>{data.name}</span>
			<span className="icon-close" onMouseDown={onRemove} role="button" />
		</Tag>
	);
};

export default SkillMultiValueLabel;
